export default __webpack_public_path__ + "static/media/chevron.f9b3b0ae.svg";